/* eslint-disable jsx-a11y/anchor-is-valid */
import _ from 'underscore';
import $ from 'jquery';
import React from 'react';
import PropTypes from 'prop-types';
import { DropdownSelector } from '@bingads-webui-react/dropdown-selector';
import { withUiBlock } from '@bingads-webui/uiblocker';

const PageSize = 10;
const MaxTotalSize = 200; // According to statics, we have about 1000 disclaimer in total, set 200 here to make sure we can get all the data
const Mode = 'async';

const PopupDisclaimerFilter = items => _.filter(items, item => _.get(item, 'DisclaimerLayout', '') === 'Popup');

export class DisclaimerSelector extends React.PureComponent {
  constructor(props) {
    super(props);

    this.isMountedFlag = false;
    this.dropdownSelectorRef = React.createRef();
    this.shouldFilterPopup = props.shouldFilterPopup;
    this.state = {
      totalCount: 0,
      items: [],
    };
  }

  componentDidMount() {
    this.isMountedFlag = true;
    this.onFetch({ pageNumber: 0 });
  }

  componentDidUpdate(prevProps) {
    if (this.props.toggleSinceUpdated !== prevProps.toggleSinceUpdated) {
      if (this.dropdownSelectorRef.current) {
        $('.search-box__input', this.dropdownSelectorRef.current.componentNode).val('');
      }
      this.onFetch({
        query: '',
        pageNumber: 0,
      });
    }
  }

  componentWillUnmount() {
    this.isMountedFlag = false;
  }

  onFetch = ({ query = '', pageNumber }) => this.props.repository.findAll({
    where: {
      name: {
        contains: query,
      },
    },
    skip: pageNumber * PageSize,
    limit: PageSize,
  })
    .then(({ items, total }) => {
      if (this.isMountedFlag) {
        const filteredItems = this.shouldFilterPopup ? PopupDisclaimerFilter(items) : items; // TODO: support filter disclaimer type in the back end
        const totalCountToInsert = this.shouldFilterPopup ? filteredItems.length : total; // We should calculate the total count in another call when we need to filter out non-popup disclaimers
        this.setState({
          items: filteredItems,
          totalCount: totalCountToInsert,
        });
      }
    })
    .then(() => {
      if (this.shouldFilterPopup) {
        this.fetchPopUpDisclaimerTotalCount({ query }); // Correct the total count for native ad scenario
      }
    });

  onEdit = extension => (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.dropdownSelectorRef.current.instanceRef.handleClickOutside(event);
    $('.disclaimer-selector .dropdown-toggle').focus();
    this.props.onEdit(extension);
  }

  onRemove = extension => (event) => {
    event.preventDefault();
    event.stopPropagation();
    // eslint-disable-next-line no-alert, no-restricted-globals
    if (confirm(`${this.props.i18n.getString('Disclaimers_Remove_Confirmation')}\n${this.props.i18n.getString('Disclaimers_Remove_Confirmation_body')}`)) {
      this.props.repository.destroy(extension.Id)
        .finally(withUiBlock($('.disclaimer-selector'), this.props.i18n.getString('Loading')))
        .then(() => {
          this.props.onRemove(extension);
        });
    }
  }

  getDropdownButtonA11yLabel = (selectedItem, i18n) => {
    const {
      Name,
    } = selectedItem;
    const label = i18n.getString('Disclaimers_Select');

    return Name ? `${Name} ${label}` : label;
  }

  fetchPopUpDisclaimerTotalCount = ({ query = '' }) => this.props.repository.findAll({
    where: {
      name: {
        contains: query,
      },
    },
    skip: 0,
    limit: MaxTotalSize,
  }).then(({ items }) => {
    if (this.isMountedFlag && this.shouldFilterPopup) {
      const filteredItems = PopupDisclaimerFilter(items); // TODO: support filter disclaimer type in the back end
      const totalCountToInsert = filteredItems.length; // We should calculate the total count in another call when we need to filter out non-popup disclaimers
      this.setState({
        totalCount: totalCountToInsert,
      });
    }
  });

  renderItem = item => (
    <li className="list-selector-option">
      <span
        className="truncated disclaimer-item-name"
        title={item.Name}
      >
        {item.Name}
      </span>
      <span className="action-right">
        <a
          href="#"
          aria-label={`${item.Name} ${this.props.i18n.getString('Edit')}`}
          className="edit"
          onClick={this.onEdit(item)}
        >
          {this.props.i18n.getString('Edit')}
        </a>
        {' | '}
        <a
          href="#"
          aria-label={`${item.Name} ${this.props.i18n.getString('Remove')}`}
          className="remove"
          onClick={this.onRemove(item)}
        >
          {this.props.i18n.getString('Remove')}
        </a>
      </span>
    </li>
  )

  renderSelectedItem = (item) => {
    const name = item && item.Id > 0 ?
      item.Name : this.props.i18n.getString('Disclaimers_Select');

    return (<span className="truncated">{name}</span>);
  }

  renderEmptyList = () => (
    <div className="empty-content">
      {this.props.i18n.getString('Search_No_Result')}
    </div>
  )

  render() {
    return (
      <div className="disclaimer-selector form-control-static">
        {((this.dropdownSelectorRef.current && $('.search-box__input', this.dropdownSelectorRef.current.componentNode).val()) ||
        (this.state.items && this.state.items.length > 0)) &&
        <DropdownSelector
          ref={this.dropdownSelectorRef}
          selectedItem={this.props.selectedDisclaimer}
          onFetch={this.onFetch}
          onSelect={this.props.onSelectDisclaimer}
          mode={Mode}
          i18n={this.props.i18n}
          totalCount={this.state.totalCount}
          items={this.state.items}
          pageSize={PageSize}
          renderItem={this.renderItem}
          renderSelectedItem={this.renderSelectedItem}
          renderEmptyList={this.renderEmptyList}
          getDropdownButtonA11yLabel={this.getDropdownButtonA11yLabel}
          enableRandomPage={this.props.enableRandomPage}
        />}
      </div>
    );
  }
}

DisclaimerSelector.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  selectedDisclaimer: PropTypes.shape({
    Id: PropTypes.number,
  }),
  repository: PropTypes.shape({
    findAll: PropTypes.func.isRequired,
    destroy: PropTypes.func.isRequired,
  }).isRequired,
  onSelectDisclaimer: PropTypes.func.isRequired,
  toggleSinceUpdated: PropTypes.bool.isRequired,
  onEdit: PropTypes.func,
  onRemove: PropTypes.func,
  shouldFilterPopup: PropTypes.bool,
  enableRandomPage: PropTypes.bool,
};

DisclaimerSelector.defaultProps = {
  enableRandomPage: true,
  selectedDisclaimer: { Id: 0 },
  onEdit: _.noop,
  onRemove: _.noop,
  shouldFilterPopup: false,
};
